import { EventEmitter, Injectable, Output } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FooterService {
  @Output() footerVisibilityChanged = new EventEmitter<boolean>();

  setFooterVisibility(isVisible: boolean){
    this.footerVisibilityChanged.emit(isVisible);
  }
}
